module.exports = "pegasus/assets/email1-column-13.png";